import {
  Button,
  Card,
  Col,
  Descriptions,
  Empty,
  Input,
  Modal,
  Row,
  Select,
  Skeleton,
  Statistic,
  Table,
  Tag,
  DatePicker,
} from "antd";
import { useEffect, useState } from "react";
import {
  toGetRelances,
  toGetRelanceDetails,
  toGetRelancesStats,
} from "./Api";
import DataTable from "react-data-table-component";
import { numberFormatCurrency, toConvertDate } from "../../../Utils/Utils";

const { RangePicker } = DatePicker;
const { Option } = Select;

const Relances = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(20);
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState({
    dateFrom: null,
    dateTo: null,
    statut: "",
    ref: "",
  });
  const [stats, setStats] = useState({ envoye: 0, echec: 0, nb: 0 });
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [isDetailVisible, setIsDetailVisible] = useState(false);

  const fetchRelances = () => {
    setIsLoading(true);
    toGetRelances(page, perPage, options).then((res) => {
      setIsLoading(false);
      if (res) {
        setData(res.res || []);
        setTotal(res.total || 0);
      }
    });
  };

  useEffect(() => {
    fetchRelances();
  }, [page, perPage]);

  useEffect(() => {
    toGetRelancesStats(30).then((res) => {
      if (res) {
        setStats(res.totals || { envoye: 0, echec: 0, nb: 0 });
      }
    });
  }, []);

  const handlePageChange = (newPage) => setPage(newPage - 1);
  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(0);
  };

  const applyFilters = () => {
    setPage(0);
    fetchRelances();
  };

  const resetFilters = () => {
    setOptions({ dateFrom: null, dateTo: null, statut: "", ref: "" });
    setPage(0);
    setTimeout(fetchRelances, 0);
  };

  const openDetail = (row) => {
    setDetailLoading(true);
    setIsDetailVisible(true);
    toGetRelanceDetails(row.id).then((res) => {
      setDetailLoading(false);
      setDetail(res);
    });
  };

  const getStatusTag = (statut) => {
    if (statut === "ENVOYE") {
      return <Tag color="green">Envoyé</Tag>;
    }
    return <Tag color="red">Échec</Tag>;
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => row.d__date,
      cell: (row) => (
        <span>{row.d__date ? toConvertDate(row.d__date) : "-"}</span>
      ),
      sortable: false,
      width: "150px",
    },
    {
      name: "Client",
      selector: (row) => row.clientName,
      cell: (row) => (
        <div>
          <b>{row.clientName || "-"}</b>
          <small style={{ display: "block", color: "#999" }}>
            {row.clientCode}
          </small>
        </div>
      ),
      width: "250px",
    },
    {
      name: "Email",
      selector: (row) => row.s__email,
      grow: 1,
    },
    {
      name: "Montant",
      selector: (row) => row.d__montant,
      cell: (row) => numberFormatCurrency(parseFloat(row.d__montant || 0)),
      right: true,
      width: "130px",
    },
    {
      name: "Factures",
      selector: (row) => row.i__nbFactures,
      right: true,
      width: "80px",
    },
    {
      name: "BLs",
      selector: (row) => row.i__nbBls,
      right: true,
      width: "60px",
    },
    {
      name: "Statut",
      selector: (row) => row.s__statut,
      cell: (row) => getStatusTag(row.s__statut),
      width: "90px",
    },
    {
      name: "Détail",
      button: true,
      minWidth: "80px",
      cell: (row) => (
        <Button type="link" size="small" onClick={() => openDetail(row)}>
          Voir
        </Button>
      ),
    },
  ];

  return (
    <div style={{ margin: "2vh 3vw" }}>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Card>
            <Statistic
              title="Envoyés (30 jours)"
              value={stats.envoye || 0}
              valueStyle={{ color: "#3f8600" }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Échecs (30 jours)"
              value={stats.echec || 0}
              valueStyle={{ color: "#cf1322" }}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Total relances (30 jours)"
              value={stats.nb || 0}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="Montant total relancé"
              value={numberFormatCurrency(parseFloat(stats.montant || 0))}
              precision={3}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: "2vh" }}>
        <Row gutter={[12, 12]} style={{ marginBottom: "2vh" }}>
          <Col span={6}>
            <RangePicker
              style={{ width: "100%" }}
              onChange={(dates) => {
                setOptions((prev) => ({
                  ...prev,
                  dateFrom: dates && dates[0] ? dates[0].format("YYYY-MM-DD") : null,
                  dateTo: dates && dates[1] ? dates[1].format("YYYY-MM-DD") : null,
                }));
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              style={{ width: "100%" }}
              value={options.statut}
              onChange={(v) => setOptions((prev) => ({ ...prev, statut: v }))}
            >
              <Option value="">Tous statuts</Option>
              <Option value="ENVOYE">Envoyé</Option>
              <Option value="ECHEC">Échec</Option>
            </Select>
          </Col>
          <Col span={6}>
            <Input
              placeholder="Rechercher client / email"
              value={options.ref}
              onChange={(e) =>
                setOptions((prev) => ({ ...prev, ref: e.target.value }))
              }
              onPressEnter={applyFilters}
            />
          </Col>
          <Col span={4}>
            <Button
              type="primary"
              onClick={applyFilters}
              icon={<span>🔍</span>}
            >
              Filtrer
            </Button>
          </Col>
          <Col span={4}>
            <Button onClick={resetFilters}>Réinitialiser</Button>
          </Col>
        </Row>

        <DataTable
          columns={columns}
          data={data}
          keyField="id"
          progressPending={isLoading}
          pagination
          paginationServer
          paginationTotalRows={total}
          paginationPerPage={perPage}
          paginationComponentOptions={{
            rowsPerPageText: "Lignes par page",
          }}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          noDataComponent={<Empty description="Aucune relance enregistrée" />}
        />
      </Card>

      <Modal
        title={detail ? detail.s__sujet : "Détail de la relance"}
        visible={isDetailVisible}
        onCancel={() => setIsDetailVisible(false)}
        footer={null}
        width={900}
      >
        {detailLoading ? (
          <Skeleton active />
        ) : detail ? (
          <div>
            <Descriptions
              bordered
              size="small"
              column={2}
              style={{ marginBottom: "2vh" }}
            >
              <Descriptions.Item label="Client">
                {detail.clientName} ({detail.clientCode})
              </Descriptions.Item>
              <Descriptions.Item label="Email">
                {detail.s__email}
              </Descriptions.Item>
              <Descriptions.Item label="Date">
                {detail.d__date ? toConvertDate(detail.d__date) : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Envoyé le">
                {detail.dt__envoye ? toConvertDate(detail.dt__envoye) : "-"}
              </Descriptions.Item>
              <Descriptions.Item label="Montant">
                {numberFormatCurrency(parseFloat(detail.d__montant || 0))}
              </Descriptions.Item>
              <Descriptions.Item label="Statut">
                {getStatusTag(detail.s__statut)}
              </Descriptions.Item>
              <Descriptions.Item label="Factures">
                {detail.i__nbFactures}
              </Descriptions.Item>
              <Descriptions.Item label="BLs">
                {detail.i__nbBls}
              </Descriptions.Item>
              {detail.s__message && (
                <Descriptions.Item label="Message" span={2}>
                  {detail.s__message}
                </Descriptions.Item>
              )}
            </Descriptions>

            <h4 style={{ margin: "1vh 0" }}>Documents inclus :</h4>
            <Table
              size="small"
              rowKey={(row, index) => "ligne-" + index}
              dataSource={detail.detail || []}
              pagination={false}
              columns={[
                {
                  title: "Type",
                  dataIndex: "typeLabel",
                  width: 100,
                },
                {
                  title: "N° document",
                  dataIndex: "numero",
                },
                {
                  title: "Date",
                  dataIndex: "date",
                  render: (v) => (v ? toConvertDate(v) : "-"),
                },
                {
                  title: "Net TTC",
                  dataIndex: "netTtc",
                  align: "right",
                  render: (v) => numberFormatCurrency(parseFloat(v || 0)),
                },
                {
                  title: "Réglé",
                  dataIndex: "regle",
                  align: "right",
                  render: (v) => numberFormatCurrency(parseFloat(v || 0)),
                },
                {
                  title: "Solde",
                  dataIndex: "solde",
                  align: "right",
                  render: (v) => numberFormatCurrency(parseFloat(v || 0)),
                },
                {
                  title: "Jours échus",
                  dataIndex: "joursEchus",
                  align: "center",
                },
              ]}
            />

            <h4 style={{ margin: "2vh 0 1vh" }}>Aperçu de l'email :</h4>
            <iframe
              srcDoc={detail.body}
              title="aperçu"
              style={{ border: "1px solid #ddd", width: "100%", height: 400 }}
              sandbox=""
            />
          </div>
        ) : (
          <Empty description="Aucune donnée" />
        )}
      </Modal>
    </div>
  );
};

export default Relances;